/* example
    const switcher = new Switcher({
        switcherButton: '.js-toggle-menu',
        dataEl: 'data-el',
        switchingItem: '.page-header',
        activeClass: 'is-active',                        //optional
        toggle: true,                                    //optional
        });
*/

export default class Switcher{
    constructor(args){
        this.switcherButton = document.querySelectorAll(args.switcherButton);
        this.dataEl = args.dataEl;
        this.switchingItem = document.querySelectorAll(args.switchingItem)
        this.activeClass = (args.activeClass) ? args.activeClass : 'is-active';
        this.toggle = (args.toggle) ? args.toggle : false;
        this.bindEvents();
    }
    bindEvents() {
        this.switcherButton.forEach(el => {
            el.addEventListener('click', ()=>{
                this.switch(el);                
            });
        });       
	} 
	switch(el) {
        let selected_item = el.getAttribute(this.dataEl);      
        selected_item = document.querySelectorAll(selected_item);
        if(this.toggle != false){
            el.classList.toggle(this.activeClass);
            selected_item.forEach(item => {
                item.classList.toggle(this.activeClass);
            });
        }else{
            this.switcherButton.forEach(item => {
                item.classList.remove(this.activeClass);
            });
            this.switchingItem.forEach(item => {
                item.classList.remove(this.activeClass);
            });
            el.classList.add(this.activeClass);
            selected_item.forEach(item => {
                item.classList.add(this.activeClass);
            });
        }
        
    }
}